import { Card, CardHeader, Media } from "reactstrap";
import { useState, useEffect } from "react";

import { PAYNENT_ACC_REPORT } from "../../../services/CONSTANTS";
import { getApiDataService } from "../../../services/apiServices";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { DataTable, FilterBar } from "components/shared";

const COLUMNS = [
  { key: "index", label: "#", className: "text-center" },
  { key: "provider", label: "Payment Provider", className: "text-center" },
  { key: "webApp", label: "Web/App", className: "text-center" },
  { key: "pos", label: "POS", className: "text-center" },
  { key: "expense", label: "Expense", className: "text-center" },
  { key: "total", label: "Total", className: "text-center" },
];

const isForeignBank = (name) =>
  name?.includes("SCB Bank") || name?.includes("Bangkok Bank");

const sumByCurrency = (reports, field, foreign) =>
  reports
    .reduce(
      (a, b) =>
        isForeignBank(b.payment_provider?.name) === foreign
          ? a + b[field]
          : a + 0,
      0
    )
    .toLocaleString("en-US");

const PaymentAccountReport = () => {
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let start = moment().startOf("day").toISOString();
  let end = moment().endOf("day").toISOString();

  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const [dateChangeEvent, setDateChangeEvent] = useState(false);

  useEffect(() => {
    console.log("start date change ", startDate);
    console.log("end date change ", endDate);
    fetchPaymentAccReport();
  }, [dateChangeEvent]);

  const handleDepositCallback = (startd, endd, label) => {
    console.log(startd.toISOString(), "startDate1");
    console.log(endd.toISOString(), "EndDate2");
    setStartDate(startd.toISOString());
    setEndDate(endd.toISOString());

    setDateChangeEvent(!dateChangeEvent);
  };

  let fetchPaymentAccReport = async () => {
    setIsLoading(true);
    let res = await getApiDataService(
      `${PAYNENT_ACC_REPORT}?start_date=${startDate}&end_date=${endDate}`
    );
    setReports(res.data);
    setIsLoading(false);
  };
  return (
    <>
      <Card className="shadow">
        <CardHeader className="border-0">
          <FilterBar title="Payment Account Report">
            <DateRangePicker onCallback={handleDepositCallback}>
              <input
                className="form-control akh-filter-width"
                placeholder="Select date range"
                aria-label="Date range"
              />
            </DateRangePicker>
          </FilterBar>
        </CardHeader>
        <DataTable
          columns={COLUMNS}
          data={reports}
          isLoading={isLoading}
          emptyMessage="No records found"
          renderRow={(item, index) => (
            <tr key={item?.id ?? index}>
              <td className="text-center" scope="row">
                {index + 1}
              </td>
              <td className="text-center" scope="row">
                <Media
                  className="align-items-center"
                  style={{
                    marginLeft: "50px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <a
                    className="rounded-circle mr-3"
                    href="#"
                    onClick={(e) => e.preventDefault()}
                  >
                    <img
                      alt="..."
                      src={item?.payment_provider?.logo}
                      style={{ width: "40px" }}
                    />
                  </a>
                  <div className="text-left">
                    <span
                      className="mb-0 text-sm"
                      style={{ fontWeight: "bold" }}
                    >
                      {item?.account_name}{" "}
                    </span>{" "}
                    <br />
                    <span className="mb-0 text-sm">{item?.account_no}</span>
                  </div>
                </Media>
              </td>
              <td className="text-center font-mono">
                {item?.total_deposit_amount?.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_manual_order_amount?.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {(-item?.total_expense_amount)?.toLocaleString("en-US")}
              </td>
              <td className="text-center font-mono">
                {item?.total_amount?.toLocaleString("en-US")}
              </td>
            </tr>
          )}
          footer={
            reports.length > 0 ? (
              <tr style={{ borderTop: "2px solid #1a174d" }}>
                <td className="text-right bg-gradient-default shadow text-white">
                  Total :
                </td>
                <td></td>
                <td className="text-center font-mono">
                  {sumByCurrency(reports, "total_deposit_amount", false)} MMK |
                  {sumByCurrency(reports, "total_deposit_amount", true)} THB
                </td>
                <td className="text-center font-mono">
                  {sumByCurrency(reports, "total_manual_order_amount", false)}{" "}
                  MMK |
                  {sumByCurrency(reports, "total_manual_order_amount", true)}{" "}
                  THB
                </td>
                <td className="text-center font-mono">
                  {sumByCurrency(reports, "total_expense_amount", false)} MMK |
                  {sumByCurrency(reports, "total_expense_amount", true)} THB
                </td>
                <td className="text-center font-mono">
                  {sumByCurrency(reports, "total_amount", false)} MMK |
                  {sumByCurrency(reports, "total_amount", true)} THB
                </td>
              </tr>
            ) : null
          }
        />
      </Card>
    </>
  );
};

export default PaymentAccountReport;
